import { sceneManager } from '../index';

class StateManager {
    constructor() {
        this.scenePrevStore = [];
        this.sceneNextStore = [];
    }

    reset () {
        this.scenePrevStore = [];
        this.sceneNextStore = [];
    }

    getSubjectState(subject) {
        if (sceneManager.loading()) {
            return
        }

        const subjectProperties = {
            info: subject.info,
            id: subject.id,
            position: subject.getPosition(),
            scale: subject.getScale(),
            rotation: subject.getRotation(),
            pose: subject.subjectType == "Character" ? subject.getPose() : null,
            jointScales: subject.subjectType == "Character" ? subject.getJointScales() : null,
            sliders: subject.sliders ? { ...subject.sliders } : null,
            objectInfo: subject.objectInfo,
            imageUrl: subject.imageUrl,
            title: subject.title,
            alive: subject.alive,
            color: subject.color,
        }

        return subjectProperties
    }

    // Each undo step is a list of subject states, so a character and its
    // attached props can be restored together
    storeSceneState (subjects = sceneManager.selectedManager.subject) {
        const currentState = [].concat(subjects).map(subject => this.getSubjectState(subject))
        if (!currentState.every(Boolean)) return

        this.scenePrevStore.push(currentState);

        if (this.scenePrevStore.length > 50) {
            this.scenePrevStore = this.scenePrevStore.slice(-50);
        }

        this.sceneNextStore = [];
    }

    findSubject (id) {
        return sceneManager.sceneCharacters.find(character => character.id === id)
        || sceneManager.sceneProps.find(prop => prop.id === id)
    }

    currentStates (states) {
        return states.map(state => this.findSubject(state.id)).filter(Boolean).map(subject => this.getSubjectState(subject))
    }

    updateScene (subjectProperties) {
        if (!subjectProperties) {
            return
        }
        
        const subject = this.findSubject(subjectProperties.id)

        if (subject) {
            if (!subject.alive && subjectProperties.alive) {
                subject.reinstate()
            } else if (subject.alive && !subjectProperties.alive) {
                subject.delete(false)
            }

            if (subject.subjectType == "Character") {
                subject.setPose(subjectProperties.pose, true, false)
                subject.setJointScales(subjectProperties.jointScales, true, false)
                if (subjectProperties.sliders) subject.setSliders(subjectProperties.sliders)
            } else {
                subject.setRotation(subjectProperties.rotation)
            }
            
            subject.setScale(subjectProperties.scale)
            subject.setPosition(subjectProperties.position)
        }
    }

    undo () {
        if (this.scenePrevStore.length > 0) {
            const prevState = this.scenePrevStore.pop();
            this.sceneNextStore.push(this.currentStates(prevState));
            prevState.forEach(state => this.updateScene(state));
        }
    }
    
    redo () {
        if (this.sceneNextStore.length > 0) {
            const nextState = this.sceneNextStore.pop();
            this.scenePrevStore.push(this.currentStates(nextState));
            nextState.forEach(state => this.updateScene(state));
        }
    }
}

export default StateManager;